import { render, staticRenderFns } from "./chooseType.vue?vue&type=template&id=22d34500&scoped=true"
import script from "./chooseType.vue?vue&type=script&lang=js"
export * from "./chooseType.vue?vue&type=script&lang=js"
import style0 from "./chooseType.vue?vue&type=style&index=0&id=22d34500&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22d34500",
  null
  
)

export default component.exports